import { render, staticRenderFns } from "./MealManagement.vue?vue&type=template&id=f9b35640&scoped=true&"
import script from "./MealManagement.vue?vue&type=script&lang=js&"
export * from "./MealManagement.vue?vue&type=script&lang=js&"
import style0 from "./MealManagement.vue?vue&type=style&index=0&id=f9b35640&scoped=true&lang=css&"
import style1 from "./MealManagement.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b35640",
  null
  
)

export default component.exports